export default {
  address: 'Address',
  contact: 'Contact',
  terms: 'Terms of Use',
  privacy_policy: 'Privacy Policy',
  impressum: 'Impressum',
  cookie_policy: 'Cookie Policy',
  cookie_settings: 'Cookie Settings',
};
